import VorsoStudyIdentifier from './VorsoStudyIdentifier.vue'
import localisations from './vorsoPilotLocalisations'

let vorsoPilot = {
  studyName: 'vorso-pilot',
  languages: ['en', 'es'], // TBD
  defaultLang: 'en',
  requiresIdentifier: true,
  identifierFormId: 'vorso-pilot-identifier',
  identifierAttribute: 'vorso-pilot-identifier-id',
  identifierComponent: VorsoStudyIdentifier,
  localisations: localisations,
  requiresBrazeConsent: true,
  brazeConsentAttribute: 'vorsoPilotConsent',
  requiresBrazeRecurring: false
}

export default vorsoPilot
